import React from 'react';
import { AlertOctagon } from 'lucide-react';
import { LanguageContext } from '../context/LanguageContext';

const errorCopy = {
  en: {
    title: 'Something went wrong',
    body: "This section couldn't load. Try refreshing the page.",
    button: 'Try Again',
  },
  de: {
    title: 'Etwas ist schiefgelaufen',
    body: 'Dieser Abschnitt konnte nicht geladen werden. Bitte aktualisiere die Seite.',
    button: 'Erneut versuchen',
  },
  es: {
    title: 'Algo salio mal',
    body: 'No se pudo cargar esta seccion. Intenta actualizar la pagina.',
    button: 'Intentar de nuevo',
  },
};

export default class ErrorBoundary extends React.Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Slide error:', error, errorInfo);
  }

  render() {
    const locale = this.context?.locale || 'en';
    const copy = errorCopy[locale] || errorCopy.en;

    if (this.state.hasError) {
      return (
        <section className="min-h-[50vh] flex items-center justify-center px-4 py-12">
          <div className="text-center max-w-md">
            <div className="flex justify-center mb-4">
              <AlertOctagon size={40} className="text-amber-500 dark:text-amber-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{copy.title}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              {copy.body}
            </p>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-4 py-2 bg-emerald-500 text-white rounded-xl text-sm font-medium hover:bg-emerald-600 transition"
            >
              {copy.button}
            </button>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
